/* Returns a function to sort an array of strings correctly on both alphabetically and numeric order.
Example: [unitC, unitA, unitB] -> [unitA, unitB, unitC]
Example: [unit2, unit10, unit1] -> [unit1, unit2, unit10]
*/

export const naturalSort = (
    compareKey = "name",
    locale: string | undefined = "sv",
    options: { [key: string]: string | boolean } = {
        numeric: true,
        sensitivity: "base",
        ignorePunctuation: true,
    }
) => {
    const sortingFunction = (a: Record<string, any>, b: Record<string, any>) =>
        a[compareKey].localeCompare(b[compareKey], locale, options);
    return sortingFunction;
};
